import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import styles from '../BookingWidget.module.css';

const codeSchema = z.object({
  code: z
    .string()
    .trim()
    .regex(/^\d{6}$/, 'Bitte den 6-stelligen Code eingeben'),
});

type CodeFormValues = z.infer<typeof codeSchema>;

interface RedeemCodeStepProps {
  email: string;
  onSubmit: (code: string) => void;
  onResend: () => void;
  isSubmitting: boolean;
  isResending: boolean;
  serverError: string | null;
  infoMessage: string | null;
}

export function RedeemCodeStep({
  email,
  onSubmit,
  onResend,
  isSubmitting,
  isResending,
  serverError,
  infoMessage,
}: RedeemCodeStepProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CodeFormValues>({
    resolver: zodResolver(codeSchema),
    defaultValues: { code: '' },
    mode: 'onSubmit',
  });

  return (
    <form
      id="yoga-redeem-code-form"
      className={styles.form}
      onSubmit={handleSubmit((values) => onSubmit(values.code.trim()))}
      noValidate
    >
      {serverError ? <p className={styles.error}>{serverError}</p> : null}
      {infoMessage ? <p className={styles.info}>{infoMessage}</p> : null}

      <p className={styles.cardMeta}>
        Code an <strong>{email}</strong> gesendet
      </p>

      <div className={styles.field}>
        <label className={styles.label} htmlFor="redeemCode">
          Zugangscode
        </label>
        <input
          id="redeemCode"
          className={styles.input}
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={6}
          disabled={isSubmitting}
          {...register('code')}
        />
        {errors.code ? (
          <span className={styles.fieldError}>{errors.code.message}</span>
        ) : null}
      </div>

      <button
        type="button"
        className={styles.linkButton}
        onClick={onResend}
        disabled={isSubmitting || isResending}
      >
        {isResending ? 'Wird gesendet…' : 'Code erneut senden'}
      </button>
    </form>
  );
}
